import { all, put, call, takeLatest, select } from 'redux-saga/effects';
import ApiService from '@/services/Api';
import actions, { actionTypes } from './actions';
import modalsActions from '../modals/actions';

function* sendInvite({ payload }) {
  const { tableOptions } = yield select(({ invites }) => ({
    tableOptions: invites.tableOptions,
  }));
  const { organization_name, ...rest } = payload;
  let requestData = payload;
  if (payload.type === 1) {
    requestData = rest;
  }

  try {
    const { data } = yield call(ApiService.sendInvite, requestData);
    yield put(actions.sendInviteSuccess(data));
    yield put(modalsActions.toggleInviteUserModal(false));
    yield put(actions.fetchInvites({ page: tableOptions.page, limit: tableOptions.limit }));
  } catch (error) {
    yield put(actions.sendInviteFailed(error));
  }
}

function* fetchInvites({ payload }) {
  try {
    const { data } = yield call(ApiService.fetchInvites, payload);
    yield put(actions.fetchInvitesSuccess(data));
  } catch (error) {
    yield put(actions.fetchInvitesFailed(error));
  }
}

function* fetchTokenData({ payload }) {
  try {
    const { data } = yield call(ApiService.fetchTokenData, payload);
    yield put(actions.fetchTokenDataSuccess(data));
  } catch (error) {
    yield put(actions.fetchTokenDataFailed(error));
  }
}

export default function* () {
  yield all([
    takeLatest(actionTypes.SEND_INVITE, sendInvite),
    takeLatest(actionTypes.FETCH_INVITES, fetchInvites),
    takeLatest(actionTypes.FETCH_TOKEN_DATA, fetchTokenData),
  ]);
}
